import React from 'react';

const GreaterThanOrEqualIcon = () => {
    return (
        <svg width="9" height="26" viewBox="0 0 16 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 2L14 10L2 18" stroke="#272727" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2 24H14" stroke="#272727" strokeWidth="3" strokeLinecap="round" />
        </svg>
    );
};

export default GreaterThanOrEqualIcon;
